/**
 * Takes an absolute asset path and prefixes it with the base path. If no base path is defined, the passed path is
 * returned unmodified.
 *
 * @param {string} path The absolute path of the asset
 * @return {string} The path, prefixed with the base path if we have one
 */
const getAssetUrl = path => {
    if (window.DMG_WIDGET_BASE_PATH) {
        // If base path is defined, use it
        return window.DMG_WIDGET_BASE_PATH + path;
    }

    // Otherwise just use the normal path
    return path;
};

export default getAssetUrl;
